import React, { useRef, useEffect } from 'react';
import Slider from 'react-slick';

const ImageCarousel = ({ images }) => {
  const sliderRef = useRef(null);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 3000,
    arrows: false,
    fade: true,
    cssEase: 'ease-in-out',
    adaptiveHeight: false,
    variableWidth: false
  };

  useEffect(() => {
    // Force slick to recalculate dimensions after mount
    if (sliderRef.current) {
      setTimeout(() => {
        sliderRef.current.slickGoTo(0);
      }, 100);
    }
  }, []);

  return (
    <div className="image-carousel">
      <Slider ref={sliderRef} {...settings}>
        {images.map((image, index) => (
          <div key={index} className="carousel-slide">
            <div className="carousel-image-wrapper">
              <img src={image} alt={`Carousel slide ${index + 1}`} className="carousel-img" />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default ImageCarousel;
